<template>
  <div class="Gachita">
        <FeatureMain2
          Card_subtitle="Fleet Management Solution"
          Card_title="가치타는 효과적으로 차량을 관리할 수 있는 관제 솔루션입니다."
          Card_description="LPWA기반의 관제 단말과 커스터마이징이 가능한 관제 플랫폼을 통해 차량을 하나처럼 통합 관리해 줄 수 있습니다. 향후, 차량과 물류를 하나로 묶어 통합관리하는 솔루션으로 발전해 나아갈 것 입니다."
          ImageSrc="gachita_main.png"
          />

        <FeatureSubs
            Card_subtitle="LPWA based Total Fleet and Asset management solution"
            Card_title="FMS"
            Card_description="It is a solution that can efficiently manage a large number of vehicles such as complex vehicle control, remote vehicle trouble diagnosis, and driving recordkeeping. (substitute Ministry of Land, Infrastructure and Transport data forms)."
            ImageSrc1="gachita_1_1.png"
            ImageSrc2="gachita_1_2.png"/>
        <FeatureSub
            Card_subtitle="Last-mile logistics management service"
            Card_title="Last-mile AMS"
            Card_description="Departure and arrival of logistics, inventory management on  a production line, Last mile logistics management solution to maximize the efficiency of material management."
            ImageSrc="gachita_2.png"
            />
        <FeatureSubs
            Card_subtitle="Car-Hailing Services for the Disabled"
            Card_title="CAR HAILING"
            Card_description="We are providing an operation management solution to ' 이유, Freedom to Move', a car hailing service for the transportation vulnerable and Disabled people, by using a combined vehicle control solution and real-time dispatch logic."
            ImageSrc1="gachita_3_1.png"
            ImageSrc2="gachita_3_2.png"/>
        <FeatureSubs
            Card_subtitle="In-Car air purification system"
            Card_title="AIR PURIFIER"
            Card_description="In recent years, We are living in bad conditions with poor air quality. It is a portable air cleaner that can be simply attached to a cup holder for good air consumption even when driving. By applying a six-layers HEPA filter, ultra-fine dust removal efficiency is enhanced and three wind speed modes can be set by touch method."
            ImageSrc1="gachita_4_1.png"
            ImageSrc2="gachita_4_2.png"/>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import FeatureMain2 from '@/components/features/FeatureMain2.vue'
import FeatureSubs from '@/components/features/FeatureSubs.vue'
import FeatureSub from '@/components/features/FeatureSub.vue'

export default {
  name: 'Gachita',
  components: {
    FeatureMain2,
    FeatureSubs,
    FeatureSub

  }
}
</script>